import { mountVueComponent } from '@/lib/mount-vue-component.js';

export default function () {
	import('./components/AIAgentsList.vue').then((aiAgentList) => {
		mountVueComponent('ai-agents-list', aiAgentList);
	});
}
